// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 8:53 PM
 */
import React from 'react';
import SsoUser from "../../model/sso/SsoUser";
import {ButtonGroup} from "reactstrap";
import SendForgotPasswordEmailButton from "../../containers/sso/SendForgotPasswordEmailButton";
import ResendActivationEmailButton from "../../containers/sso/ResendActivationEmailButton";
import ActivateUserButton from "../../containers/sso/ActivateUserButton";
import TableRow from "../util/tables/TableRow";
import TableCell from "../util/tables/TableCell";
import {Country} from "../../model/Country";
import {findCountryNameByCountryCode} from "../../helpers/utils";
import moment from "moment/moment";
import config from '../../config/config';
import SsoUserEmailButton from "../sso/SsoUserEmailButton";

type SsoUserTableRowProps = {
    ssoUser: SsoUser,
    countries: Array<Country>
};

export default function SsoUserTableRow(props: SsoUserTableRowProps) {
    const user = props.ssoUser;
    return (
        <TableRow>
            <TableCell>{user.companyName}</TableCell>
            <TableCell>{user.firstName}</TableCell>
            <TableCell>{user.lastName}</TableCell>
            <TableCell>{findCountryNameByCountryCode(props.countries, user.countryCode)}</TableCell>
            <TableCell>{config.enableTheLinkInEmailField ? <SsoUserEmailButton email={user.email}/> : user.email}</TableCell>
            <TableCell>{moment.utc(user.createDate).local().format('YY-MM-DD HH:mm')}</TableCell>
            <TableCell>{moment.utc(user.lastModifiedDate).local().format('YY-MM-DD HH:mm')}</TableCell>
            <TableCell>{user.status}</TableCell>
            <TableCell>
                <ButtonGroup>
                    {
                        user.status === "active" &&
                        <SendForgotPasswordEmailButton loadingComponent={<span>Sending..</span>} block ssoUid={user.ssoUid} label="Send Reset Password Email" color={"success"}/>
                    }
                    {
                        user.status === "inactive" &&
                        <ResendActivationEmailButton loadingComponent={<span>Sending..</span>} ssoUid={user.ssoUid} label="Send Activation Email" color={"success"} />
                    }
                    {
                        user.status === "inactive" &&
                        <ActivateUserButton loadingComponent={<span>Activating..</span>} ssoUid={user.ssoUid} label={"Activate User"} color={"danger"}/>
                    }
                </ButtonGroup>
            </TableCell>
        </TableRow>);
};


// WEBPACK FOOTER //
// ./src/components/sso/SsoUserTableRow.js